'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Subheading = function Subheading(_ref) {
    var text = _ref.text,
        theme = _ref.theme,
        stylizr = _ref.stylizr;
    return _react2.default.createElement(
        'h2',
        { className: theme.subheading, 'data-test-tag': '@spp/ui-subheading' },
        stylizr(text.value, text.markup)
    );
};

Subheading.propTypes = {
    text: _irisPropTypes.objects.text.isRequired,
    stylizr: _propTypes2.default.func.isRequired,
    theme: _propTypes2.default.shape({
        subheading: _propTypes2.default.string
    })
};

Subheading.defaultProps = {
    stylizr: function stylizr(text) {
        return text;
    },
    theme: {}
};

exports.default = Subheading;
//# sourceMappingURL=Subheading.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-subheading/lib/cjs/Subheading.js
 ** module id = 526
 ** module chunks = 1
 **/